import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

const DeleteModal = ({ showModal, setShowModal, deleteDates, deleteModalData, deleteUser }) => {
    return (
        <Modal isOpen={showModal} className="modal-centered contract-type-modal feedback-modal-style link-form">
            <ModalHeader toggle={() => setShowModal(!showModal)} className='px-3 mt-4'>{
                deleteModalData?.type === 'dagdeel' ? ' Dagdeel' : 'Vervanger verwijderen'
            }</ModalHeader>

            <ModalBody className='text-center mt-4 mb-4'>
                <p className="contracttype-Modal">
                    {
                        deleteModalData?.type === 'dagdeel' ? ' Dagdeel verwijderen?' : 'Vervanger voor dit dagdeel verwijderen?'
                    }
                </p>
            </ModalBody>
            <ModalFooter className='justify-content-center pt-3'>
                <>
                    <Button color="link" onClick={() => {
                        if (deleteModalData?.type === 'dagdeel') {
                            deleteDates(deleteModalData?.data?.iSubsDateId)
                        } else {
                            const payload = {
                                iSubstitutionId: deleteModalData?.data?.iSubstitutionId,
                                iSubDateId: deleteModalData?.data?.iSubsDateId,
                                iSubstitutorAdminId: deleteModalData?.data?.iSubstitutorAdminId,
                            }
                            deleteUser(payload);
                        }
                    }} className={"btn-color-style"}>
                        Ja
                    </Button>
                    <Button color="link" onClick={() => setShowModal(false)} className={"btn-color-style"}>
                        Nee
                    </Button>
                </>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteModal
